import React from 'react';
import { Alert } from '@edx/paragon';
import { Warning } from '@edx/paragon/icons';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

const retirementBanner = () => (
  <Alert variant="warning">
    <div className="d-flex align-items-end justify-content-center">
      <Warning className="warning-icon mr-2" />
      <FormattedMessage
        id="prospectus.course.retirement-warning"
        description="Warning banner text signifying a course will be retiring soon"
        defaultMessage="This course is retiring soon"
      />
    </div>
  </Alert>
);

export default retirementBanner;
